const materialsBill = {
    namespaced: true,
    state: {
        combination_dialogShow: false, // 材料组合组件弹窗开关
        operationTitle: '' // 材料组合组件弹窗标题
    },
    mutations: {
        updateCombination_dialogShow(state, data) {
            state.combination_dialogShow = data
        },

        updateOperationTitle(state, data) {
            state.operationTitle = data
        }
    }
}

export default materialsBill


// WEBPACK FOOTER //
// ./src/store/modules/materialsBill.js